import typography from 'shared-tokens/utils/tokens/typography';

export const mainCls = 'callagency-qrcode';

export default {
  [`${mainCls}`]: {
    position: 'absolute',
    top: '44px',
    right: '6px',
    color: 'white',
    width: '285px',
    visibility: 'hidden',
    opacity: 0,
    padding: '12px 16px 16px 16px',
    borderRadius: '4px',
    border: '2px solid #1A1F24',
    background: '#fff',
    transition: 'opacity 0.3s ease-in-out',
    lineHeight: 'normal',
    alignItems: 'end',
    zIndex: 7,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '-9px',
      left: '70px',
      width: '0',
      height: '0',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      borderBottom: '8px solid #1A1F24',
    },
    '&::before': {
      content: '""', 
      position: 'absolute',
      top: '-7px',
      left: '72px',
      width: '0',
      height: '0',
      borderLeft: '7px solid transparent',
      borderRight: '7px solid transparent',
      borderBottom: '7px solid #fff',
      zIndex: 1,
    }
  },
  [`${mainCls}--card-header`]: {
    top: '44px',
    left: '0',
  },
  [`${mainCls}--pdp-descr`]: {
    top: '-66px',
    left: '130px',
    '&::after': {
      top: '66px',
      left: '-17px',
      borderBottom: '9px solid transparent',
      borderTop: '9px solid transparent',
      borderRight: '8px solid #1A1F24',
    },
    '&::before': {
      top: '68px',
      left: '-13px',
      borderBottom: '7px solid transparent',
      borderTop: '7px solid transparent',
      borderRight: '7px solid #fff',
    },

  },
  [`${mainCls}--pdp-gallery`]: {
    top: '60px',
    right: '-74px',
  },
  [`${mainCls}--agency-srp`]: {
    left: '0',
    right: 'auto',
  },
  [`${mainCls}--agent-pro`]: {
    right: 'auto',
    left: '23px',
  },
  [`${mainCls}--no-results`]: {
    top: '60px',
    left: '8px',
    
  },
  
  [`${mainCls}__visible`]: {
    visibility: 'visible',
    opacity: 1,
  },
  [`${mainCls}__header`]: {
    justifyContent: 'end',
    width: '18px',
    height: '18px',
    border: '2px solid #fff', 
    borderRadius: '50%',
    padding: '2px',
    margin: '-2px',
    alignItems: 'center',
    '& path': {
      strokeWidth: '2',
    },
    '&:hover': {
      border: '2px solid #F8F9FA',
      color: '#1A1F24 !important',
      backgroundColor: 'rgba(57, 67, 78, 0.08)',
    },
    '&:active': {
      border: '2px solid #F0F2F5',
      color: '#96A1B0 !important',
    },
  },
  [`${mainCls}__header_close`]: {
    color: '#1A1F24 !important',
    cursor: 'pointer',
    '&:hover': {
      color: '#39434e !important',
    },
  },
  [`${mainCls}__text`]: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  [`${mainCls}__left_cnt`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '140px',
  },
  [`${mainCls}__info`]: {
    borderRadius: '50%',
    border: '1px solid #505A65',
    height: '14px',
    width: '14px',
    fontSize: '10px',
    textAlign: 'center',
  },
  [`${mainCls}__how_works`]: {
    cursor: 'pointer',
    '&.disabled': {
      cursor: 'default',
    },
  },
  [`${mainCls}__expanded-txt`]: {
    maxWidth: '248px',
  },
};
